import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import { useTranslation } from 'react-i18next';

import { createTheme, ThemeProvider } from '@mui/material/styles';

function Intake({answers}) {
    const {t} = useTranslation('global');

    const getMuiTheme = () => createTheme({
        components: {
            MuiTableContainer:{
                styleOverrides:{
                    root: {
                        border:'1px solid #ccc',
                        borderRadius: '5px',
                        fontFamily: 'Open Sans'
                    }
                }
            },
            MuiTableCell:{
                styleOverrides:{
                  root: {
                    lineHeight:'16px',
                    fontFamily: 'Open Sans'
                  }
                }
              },
        }
    })


  return (
    <div style={{width:'39%', marginRight:'5px'}}>
        <ThemeProvider theme={getMuiTheme()}>
            <TableContainer >
                <Table  size="small"  sx={{
                borderCollapse: "collapse",
                borderStyle: "hidden",
                "& td": {
                    border:'1px solid #CCC'
                }
                }}>
                    <TableHead sx={{
                        "& th": {
                        backgroundColor: "#def1fc",
                        color: "black",
                        fontWeight:600,
                        },
                        "& th:hover": {
                        backgroundColor: "#c9e8fa",
                        }
                    }}>
                        <TableRow>
                            <TableCell> {t('help_needed_for_any_of_these_activities')}</TableCell>
                            <TableCell> Answers </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {answers?.helpTurning &&
                        <TableRow>
                            <TableCell>
                              
                                {answers?.helpTurning?.question}
                            </TableCell> 
                            <TableCell>
                                {answers?.helpTurning?.answer}
                            </TableCell>
                        </TableRow>
                    }

                    {answers?.helpSitting && 
                        <TableRow>
                            <TableCell>
                             
                                {answers?.helpSitting?.question}
                            </TableCell> 
                            <TableCell>
                                {answers?.helpSitting?.answer}
                            </TableCell>
                        </TableRow>
                    }

                    {answers?.helpMoving && 
                        <TableRow>
                            <TableCell>
                             
                                {answers?.helpMoving?.question}
                            </TableCell> 
                            <TableCell>
                                {answers?.helpMoving?.answer}
                            </TableCell>
                        </TableRow>
                    }

                    {answers?.helpStanding && 
                        <TableRow>
                            <TableCell>
                               
                                {answers?.helpStanding?.question}
                            </TableCell> 
                            <TableCell>
                                {answers?.helpStanding?.answer}
                            </TableCell>
                        </TableRow>
                    }

                    {answers?.helpClimbing && 
                        <TableRow>
                            <TableCell>
                              
                                {answers?.helpClimbing?.question}
                            </TableCell> 
                            <TableCell>
                                {answers?.helpClimbing?.answer}
                            </TableCell>
                        </TableRow>
                    }

                      

                    {answers?.walkHowFar &&
                        <TableRow>
                            <TableCell>
                              
                                {answers?.walkHowFar?.question}
                            </TableCell> 
                            <TableCell>
                                {answers?.walkHowFar?.answer}
                            </TableCell>
                        </TableRow>
                    }
                    
                    {answers?.gaitAid && 
                        <TableRow>
                            <TableCell>
                               
                                {answers?.gaitAid?.question}
                            </TableCell> 
                            <TableCell>
                                {answers?.gaitAid?.answer}
                            </TableCell>
                        </TableRow>
                    }

                    {answers?.communitySupports && 
                        <TableRow>
                            <TableCell >
                               
                                {answers?.communitySupports?.question}
                            </TableCell> 
                            <TableCell>
                                {answers?.communitySupports?.answer}
                            </TableCell>
                        </TableRow>
                    }

                    {answers?.liveWithCarer && 
                        <TableRow>
                            <TableCell>
                              
                                {answers?.liveWithCarer?.question}
                            </TableCell> 
                            <TableCell>
                                {answers?.liveWithCarer?.answer}
                            </TableCell>
                        </TableRow>
                    }
                    {answers?.rapt && 
                        <TableRow>
                            <TableCell>
                                
                                {answers?.rapt?.question}
                            </TableCell> 
                            <TableCell>
                            {answers?.rapt?.answer}
                            </TableCell>
                        </TableRow> 
                    }
                    {answers?.bmi && 
                        <TableRow>
                            <TableCell>
                                
                                {answers?.bmi?.question}
                            </TableCell> 
                            <TableCell>
                            {answers?.bmi?.answer}
                            </TableCell>
                        </TableRow>
                    }
                    </TableBody>
                </Table>
            </TableContainer>
        </ThemeProvider>
    </div>
  )
}

export default Intake